module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/board/plank-right-19.png"+" 19w",
        images: [{path: __webpack_public_path__ + "assets/images/board/plank-right-19.png",width: 19,height: 240}],
        src: __webpack_public_path__ + "assets/images/board/plank-right-19.png",
        toString: function(){return __webpack_public_path__ + "assets/images/board/plank-right-19.png"},
        
        width: 19,
        height: 240
      }